<script>
import VueApexCharts from "vue-apexcharts";
import _ from "lodash";

export default {
  name: "SecurityChart",
  components: {VueApexCharts},
  props: {
    endpoints: {
      type: Array,
      required: true
    }
  },
  computed: {
    isSecure: function () {
      let endpointGroupedByDomain = _.groupBy(this.endpoints, 'is_secure')
      return Object.keys(endpointGroupedByDomain).map(isSecure => {
        return {
          isSecure: isSecure,
          total: endpointGroupedByDomain[isSecure].length,
        }
      })
    },
    chartSeries: function () {
      return this.isSecure.map(isSecure => isSecure.total)
    },
    chartOptions: function () {
      return {
        chart: {
          width: 900,
          type: 'pie',
        },
        labels: this.isSecure.map(isSecure => isSecure.isSecure)
      }
    }
  },
}
</script>

<template>
  <vx-card title="Seguridad">
    <vue-apex-charts
        v-if="chartSeries.length > 0"
        type="pie"
        id="security-chart"
        height="800"
        :options="chartOptions"
        :series="chartSeries"
    />
  </vx-card>
</template>

<style scoped>

</style>